exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "file .remove-file{color:red}file .right span.file-name{padding-left:25px;font-size:14px;font-weight:700;color:#898989}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./directives/freeforms/file/file.scss
// module id = 392
// module chunks = 0